











import { Vue, Prop, Component } from "vue-property-decorator"

@Component({})
export default class IngredientsList extends Vue {
	@Prop({ required: true }) recipe!: RecipeObject;
	@Prop({ required: true }) numberOfPortions!: number;
}
